'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.mapDispatchToProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objAsArray = require('shared/utils/objAsArray');

var _objAsArray2 = _interopRequireDefault(_objAsArray);

var _dynamicSort = require('shared/utils/dynamicSort');

var _dynamicSort2 = _interopRequireDefault(_dynamicSort);

var _actions = require('./actions');

var _getMatchingJobs = require('shared/utils/match/getMatchingJobs');

var _getMatchingJobs2 = _interopRequireDefault(_getMatchingJobs);

var _constants = require('shared/utils/match/constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: {
      changeCategory: function changeCategory(category) {
        return dispatch((0, _actions.changeCategory)(category));
      },
      changeInterestValue: function changeInterestValue(id, value) {
        return dispatch((0, _actions.changeInterestValue)(id, value));
      },
      changeSkill: function changeSkill(id) {
        return dispatch((0, _actions.changeSkill)(id));
      },
      changeEducation: function changeEducation(id) {
        return dispatch((0, _actions.changeEducation)(id));
      }
    }
  };
};

//const getSelectedEducationLevelIndex = (levels, userEducation) => {
//return levels.map(level => level.id).indexOf(userEducation) + 1;
//};

//const getSliceOfEducation = (levels, start, end, selected) => {
//return levels.slice(start, end).map(level => ({
//...level,
//selected,
//}));
//};

//const getSelectedEducationLevels = (levels, userEducation) => {
//const index = getSelectedEducationLevelIndex(levels, userEducation);
//const selectedLevels = getSliceOfEducation(levels, 0, index, true);
//const unselectedLevels = getSliceOfEducation(levels, index, levels.length, false);
//return selectedLevels.concat(unselectedLevels);
//};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
  var ui = _ref.ui,
      user = _ref.user,
      data = _ref.data;
  var _ui$matcher = ui.matcher,
      sectionLabels = _ui$matcher.sectionLabels,
      currentCategory = _ui$matcher.currentCategory,
      categories = _ui$matcher.categories;


  var jobs = data.jobs;
  var subsectors = data.subsectors;
  var skills = (0, _objAsArray2.default)(data.skills).sort((0, _dynamicSort2.default)("label"));
  var interests = (0, _objAsArray2.default)(data.interests);
  var educationLevels = (0, _objAsArray2.default)(data.educationLevels);

  return {
    sectionLabels: sectionLabels,
    categories: categories,
    skills: skills.map(function (skill) {
      return (0, _extends3.default)({}, skill, {
        selected: user.skills.indexOf(skill.id) !== -1
      });
    }),
    interests: interests.map(function (interest) {
      var userInterest = user.interests[interest.id];
      return (0, _extends3.default)({}, interest, {
        values: [{
          id: 'user',
          value: userInterest !== undefined ? userInterest : _constants2.default.INTERESTS.DEFAULT
        }]
      });
    }),
    educationLevels: educationLevels.map(function (education) {
      return (0, _extends3.default)({}, education, {
        selected: user.education === education.id
      });
    }),
    currentCategory: currentCategory,
    jobs: (0, _getMatchingJobs2.default)(jobs, user, {
      skills: skills,
      interests: interests,
      educationLevels: educationLevels
    }).map(function (job) {
      return (0, _extends3.default)({}, job, {
        subsectors: job.subsectors.map(function (sectorID) {
          return (0, _extends3.default)({}, subsectors[sectorID]);
        })
      });
    }),
    loadingJobs: false
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Matcher/selectors.js
// module id = 1242
// module chunks = 0